import { MutableRefObject } from 'react'
import { ErrorState } from "../Types"
import { SetState, Validate } from "../validation"
import * as yup from "yup"
import { ButtonDropdownItem } from '../buttons'

export enum FileDownloadFormats {
    Pdf = "Pdf",
    Word = "Word",
}

export interface FormContext<M> {
    model: M
    page: number
    readOnly: boolean
    onSaveEnabled: boolean
    additionalDownloadButtons?: ButtonDropdownItem[]
    getNextPage: (page: number, v: M) => number
    getPreviousPage: (page: number, v: M) => number
    onChange: (m: M, commit?: boolean) => void
    onNavigate: (d: M, newPage?: number | boolean, submit?: boolean) => Promise<M | null>
    onLoading: (text: string | null) => any
    onError: (error: string | null) => any
    onPrint?: (d: M, format: FileDownloadFormats) => any
}

export interface FormPageContext<M extends {}> extends FormContext<M> {
    setModel: SetState<M>
    errors: ErrorState<M>
    validate: Validate
    gridRefs: MutableRefObject<{[key:number]:FormGridMehods<M, any>}>
    resetErrorsFlag: ()=> Promise<void>
}

export interface FormGridMehods<M, R> {
    getUncommited: (revalidate: boolean, colapse: boolean) => Promise<[R[], boolean]>
    setRows: (model: M, rows: R[]) => M
    revalidate: () => void
}

export interface FormGridDetailsMehods<R> {
    getUncommited: (revalidate: boolean) => Promise<[R | null, R, boolean]>
}

export interface FormGridContext<R extends {}> {
    row: R | null,
    onChange: (current: R | null, update: R | null) => any,
    schema: yup.ObjectSchema<R>,
    readOnly: boolean,
    detailsRef: React.RefObject<FormGridDetailsMehods<R>>
    invalid: boolean
}

export interface FormGridDetailsContext<R extends {}> {
    model: R
    setModel: SetState<R>
    errors: ErrorState<R>
    validate: Validate
    readOnly: boolean
}